import { useContext, useState } from 'react';
import { CheckCircle, BarChart3, Shield,Target,Clock, Users, Rocket, Sun, Phone, Mail, MapPin, Menu, X, ClipboardCheck, ListChecks, Loader2 } from 'lucide-react';
import { Link } from 'react-router-dom';
import AuthContext from '../context/AuthContext';
import contactUsService from '../services/contactUsService';

import analyticImage from "../assets/images/testImage5.jpg";
import illustration from "../assets/images/business-anlytic.png";

const bannerImage = {
  backgroundImage: `url(${analyticImage})`
};

export default function WelcomePage() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeTab, setActiveTab] = useState('assistance'); // 'assistance' or 'account'

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    telephone: '',
    message: ''
  });
  const [errors, setErrors] = useState({});
  const [submitStatus, setSubmitStatus] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

    // account creation request state variables
  const [accountFormData, setAccountFormData] = useState({
    name: '',
    service: '',
    contact: '',
    reason: '',
    email: '',
    first_name: '',
    last_name: '',
    organisation_description: '',
  });
  const [accountErrors, setAccountErrors] = useState({});
  const [accountSubmitStatus, setAccountSubmitStatus] = useState(null);
  const [isAccountSubmitting, setIsAccountSubmitting] = useState(false);

  let {name} = useContext(AuthContext);

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    if (errors[e.target.name]) {
      setErrors({
        ...errors,
        [e.target.name]: ''
      });
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = 'Le nom est requis';
    }

    if (!formData.email.trim()) {
      newErrors.email = 'L\'email est requis';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = 'Veuillez entrer un email valide';
    }

    if (!formData.message.trim()) {
      newErrors.message = 'Le message est requis';
    } else if (formData.message.trim().length < 10) {
      newErrors.message = 'Le message doit contenir au moins 10 caractères';
    }

    if (formData.telephone.trim() && !/^[\d\s+\-()]+$/.test(formData.telephone)) {
      newErrors.telephone = 'Veuillez entrer un numéro de téléphone valide';
    }

    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitStatus(null);

    const newErrors = validateForm();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setIsSubmitting(true);
    try {
      const response = await contactUsService.contactUs(formData);
      
      if (response.success) {
        setSubmitStatus({
          type: 'success',
          message: 'Message envoyé avec succès! Nous vous recontacterons bientôt.'
        });
        setFormData({ name: '', email: '', telephone: '', message: '' });
        setErrors({});
      } else {
        setSubmitStatus({
          type: 'error',
          message: response.error || 'Erreur lors de l\'envoi du message'
        });
      }
    } catch (error) {
      setSubmitStatus({
        type: 'error',
        message: 'Une erreur est survenue. Veuillez réessayer.'
      });
    } finally {
      setIsSubmitting(false);
    }
  };





    // Account creation methods
    const handleAccountInputChange = (e) => {
      setAccountFormData({
        ...accountFormData,
        [e.target.name]: e.target.value
      });
      if (accountErrors[e.target.name]) {
        setAccountErrors({
          ...accountErrors,
          [e.target.name]: ''
        });
      }
    };

    const validateAccountForm = () => {
      const newErrors = {};

      if (!accountFormData.name.trim()) {
        newErrors.name = 'Le nom est requis';
      }

      if (!accountFormData.service.trim()) {
        newErrors.service = 'Le service est requis';
      }

      if (!accountFormData.contact.trim()) {
        newErrors.contact = 'Le contact est requis';
      }

      if (!accountFormData.reason.trim()) {
        newErrors.reason = 'La raison est requise';
      } else if (accountFormData.reason.trim().length < 10) {
        newErrors.reason = 'La raison doit contenir au moins 10 caractères';
      }

      if (!accountFormData.email.trim()) {
        newErrors.email = 'L\'email est requis';
      } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(accountFormData.email)) {
        newErrors.email = 'Veuillez entrer un email valide';
      }

      return newErrors;
    };

    const handleAccountSubmit = async (e) => {
      e.preventDefault();
      setAccountSubmitStatus(null);

      const newErrors = validateAccountForm();
      if (Object.keys(newErrors).length > 0) {
        setAccountErrors(newErrors);
        return;
      }

      setIsAccountSubmitting(true);
      try {
        const response = await contactUsService.accountCreationRequest(accountFormData);
        
        if (response.success) {
          setAccountSubmitStatus({
            type: 'success',
            message: 'Demande de création de compte envoyée avec succès! Nous vous recontacterons bientôt.'
          });
        setAccountFormData({ name: '', service: '', contact: '', reason: '', email: '', first_name: '', last_name: '', organisation_description: '' });
          setAccountErrors({});
        } else {
          setAccountSubmitStatus({
            type: 'error',
            message: response.error || 'Erreur lors de l\'envoi de la demande'
          });
        }
      } catch (error) {
        setAccountSubmitStatus({
          type: 'error',
          message: 'Une erreur est survenue. Veuillez réessayer.'
        });
      } finally {
        setIsAccountSubmitting(false);
      }
    };
  return (
    <div className="min-h-screen bg-white">
      {/* Navbar - Black Theme */}
      <header className="bg-black shadow-lg border-b border-gray-800 relative z-50">
        <div className="container mx-auto px-4 sm:px-6">
          <div className="flex justify-between items-center h-16">
            <div className="flex-shrink-0">
              <div className="text-xl font-bold text-white">
                Carto<span className="text-green-500">pousse</span>
              </div>
            </div>

            {/* Desktop Navigation */}
            <nav className="hidden md:flex items-center space-x-8">
              <a href="#fonctionnalites" className="text-gray-300 hover:text-green-500 transition-colors text-sm font-medium">
                Fonctionnalités
              </a>
              <a href="#apropos" className="text-gray-300 hover:text-green-500 transition-colors text-sm font-medium">
                À propos
              </a>
              <a href="#contact" className="text-gray-300 hover:text-green-500 transition-colors text-sm font-medium">
                Contact
              </a>
          
              <Link to="/login" className="bg-green-600 text-white px-6 py-2 rounded-lg hover:bg-green-700 transition-all duration-300 text-sm font-medium shadow-lg hover:shadow-green-500/50">
                Commencer
              </Link>
            </nav>

            {/* Mobile menu button */}
            <div className="md:hidden">
              <button
                onClick={() => setIsMenuOpen(!isMenuOpen)}
                className="text-gray-300 hover:text-white focus:outline-none transition-colors"
              >
                {isMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
              </button>
            </div>
          </div>

          {/* Mobile Navigation */}
          {isMenuOpen && (
            <div className="md:hidden border-t border-gray-800 bg-black absolute top-16 left-0 right-0 shadow-2xl">
              <nav className="py-4 space-y-1 px-4">
                <a href="#fonctionnalites" className="block px-4 py-3 text-gray-300 hover:text-green-500 hover:bg-gray-900 transition-colors text-sm rounded-lg font-medium">
                  Fonctionnalités
                </a>
                <a href="#apropos" className="block px-4 py-3 text-gray-300 hover:text-green-500 hover:bg-gray-900 transition-colors text-sm rounded-lg font-medium">
                  À propos
                </a>
                <a href="#contact" className="block px-4 py-3 text-gray-300 hover:text-green-500 hover:bg-gray-900 transition-colors text-sm rounded-lg font-medium">
                  Contact
                </a>
                <div className="pt-2">
                  <Link to="/login" className="block w-full bg-green-600 text-white px-4 py-3 rounded-lg hover:bg-green-700 transition-all duration-300 text-sm text-center font-medium shadow-lg">
                    Commencer
                  </Link>
                </div>
              </nav>
            </div>
          )}
        </div>
      </header>

      {/* Hero Section - Improved Design */}

      {/* Hero Section - Improved Design */}
    <section
        className="relative h-[65vh] min-h-[500px] max-h-[700px] flex items-center bg-gray-900 text-white pt-24 pb-12 md:pt-28 md:pb-16 bg-cover bg-center bg-no-repeat"
        style={bannerImage}
      >
        {/* Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-br from-black/70 via-black/60 to-green-900/40"></div>
        
        {/* Animated Background Elements */}
        <div className="absolute inset-0 overflow-hidden">
          <div className="absolute top-20 left-10 w-72 h-72 bg-green-500/10 rounded-full blur-3xl animate-pulse"></div>
          <div className="absolute bottom-20 right-10 w-96 h-96 bg-green-600/10 rounded-full blur-3xl animate-pulse delay-700"></div>
        </div>

        {/* Content */}
        <div className="relative container mx-auto px-4 sm:px-6 max-w-4xl z-10">
          <div className="text-center space-y-8">
            {/* Badge */}
            {/* <div className="inline-flex items-center gap-2 bg-green-500/20 backdrop-blur-sm border border-green-500/30 rounded-full px-5 py-2 mb-4">
              <Shield className="w-4 h-4 text-green-400" />
              <span className="text-sm font-medium text-green-300">Solution de gestion des risques</span>
            </div> */}

            {/* Main Heading */}
            <h1 className="text-4xl md:text-6xl font-extrabold leading-tight">
              La gouvernance des{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-green-400 to-emerald-400">
                risques et audits
              </span>
              <br />
              en toute sérénité
            </h1>

            {/* Subheading */}
            <p className="text-lg md:text-xl text-gray-300 max-w-2xl mx-auto leading-relaxed">
              Une plateforme{' '}
              <span className="text-green-400 font-semibold">complète et intuitive</span>
              {' '}pour cartographier vos risques, piloter vos audits et gérer vos actions de contrôle interne en toute sérénité.
            </p>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center pt-4">
              <a
                href="#fonctionnalites"
                className="group inline-flex items-center gap-2 bg-green-600 text-white px-8 py-4 rounded-xl text-base font-semibold hover:bg-green-700 transition-all duration-300 shadow-xl hover:shadow-green-500/50 hover:scale-105"
              >
                Découvrir les fonctionnalités
                <svg className="w-5 h-5 group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                </svg>
              </a>
              
              <Link
                to="/login"
                className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm text-white px-8 py-4 rounded-xl text-base font-semibold hover:bg-white/20 transition-all duration-300 border border-white/20"
              >
                Commencer maintenant
              </Link>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-8 max-w-2xl mx-auto pt-12">
              {/* <div className="text-center">
                <div className="text-3xl md:text-4xl font-bold text-green-400 mb-1">100+</div>
                <div className="text-sm text-gray-400">Entreprises</div>
              </div> */}
              <div className="text-center">
                <div className="text-3xl md:text-4xl font-bold text-green-400 mb-1">99%</div>
                <div className="text-sm text-gray-400">Satisfaction</div>
              </div>
              <div className="text-center">
                <div className="text-3xl md:text-4xl font-bold text-green-400 mb-1">24/7</div>
                <div className="text-sm text-gray-400">Support</div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Wave */}
        <div className="absolute  bottom-0 left-0 right-0">
          <svg  viewBox="0 0 1440 120" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-auto ">
            <path d="M0 120L60 105C120 90 240 60 360 45C480 30 600 30 720 37.5C840 45 960 60 1080 67.5C1200 75 1320 75 1380 75L1440 75V120H1380C1320 120 1200 120 1080 120C960 120 840 120 720 120C600 120 480 120 360 120C240 120 120 120 60 120H0Z" fill="#F9FAFB"/>
          </svg>
        </div>
      </section>

      {/* Key Features Section */}
      <section id="fonctionnalites" className="py-20 bg-gray-50">
        <div className="container mx-auto px-4 sm:px-6">
          <div className="text-center mb-16">
            <div className="inline-flex items-center justify-center gap-2 bg-green-100 rounded-full px-4 py-2 mb-4">
              <Rocket className="text-green-600 h-5 w-5" />
              <span className="text-green-700 font-semibold text-sm">Fonctionnalités clés</span>
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              2.5 Cartopousse
            </h2>
            <p className="text-gray-600 max-w-2xl mx-auto">
              Des outils puissants pour cartographier et gérer vos processus efficacement
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
            <div className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1 group">
              <div className="bg-gradient-to-br from-blue-400 to-blue-600 w-16 h-16 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                <CheckCircle className="text-white h-8 w-8" />
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-3">Cartographie des processus</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                Visualisez et documentez vos processus métier avec clarté et précision.
              </p>
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1 group">
              <div className="bg-gradient-to-br from-red-400 to-red-600 w-16 h-16 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                <Shield className="text-white h-8 w-8" />
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-3">Gestion des risques</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                Identifiez, évaluez et suivez les risques associés à chaque processus.
              </p>
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1 group">
              <div className="bg-gradient-to-br from-green-400 to-green-600 w-16 h-16 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                <Users className="text-white h-8 w-8" />
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-3">Assignation des responsables</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                Définissez clairement les rôles et responsabilités pour chaque processus.
              </p>
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1 group">
              <div className="bg-gradient-to-br from-purple-400 to-purple-600 w-16 h-16 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                <Target className="text-white h-8 w-8" />
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-3">Suivi des actions correctives</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                Planifiez et suivez la mise en œuvre des actions d'amélioration continue.
              </p>
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1 group">
              <div className="bg-gradient-to-br from-orange-400 to-orange-600 w-16 h-16 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                <Clock className="text-white h-8 w-8" />
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-3">Historisation</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                Conservez l'historique complet de vos processus et modifications.
              </p>
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1 group">
              <div className="bg-gradient-to-br from-emerald-400 to-emerald-600 w-16 h-16 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                <ClipboardCheck className="text-white h-8 w-8" />
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-3">Gestion des audits</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                Planifiez vos audits, suivez l'avancement et assurez la traçabilité des contrôles.
              </p>
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1 group">
              <div className="bg-gradient-to-br from-teal-400 to-teal-600 w-16 h-16 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                <ListChecks className="text-white h-8 w-8" />
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-3">Contrôle interne</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                Pilotez les recommandations et actions correctives, avec suivi des échéances et des statuts.
              </p>
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1 group">
              <div className="bg-gradient-to-br from-cyan-400 to-cyan-600 w-16 h-16 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                <BarChart3 className="text-white h-8 w-8" />
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-3">KPI & Indicateurs</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                Suivez les processus optimisés, le taux de conformité, les incidents et les anomalies.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section id="apropos" className="py-20 bg-white">
        <div className="container mx-auto px-4 sm:px-6">
          <div className="text-center mb-12">
            <div className="inline-flex items-center justify-center gap-2 bg-green-100 rounded-full px-4 py-2 mb-4">
              <Sun className="text-green-600 h-5 w-5" />
              <span className="text-green-700 font-semibold text-sm">À propos</span>
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              À propos de Cartopousse
            </h2>
          </div>
          
          <div className="max-w-3xl mx-auto space-y-6 text-gray-700 text-base leading-relaxed">
            <p className="text-lg">
              Cartopousse est un outil moderne conçu pour simplifier la gestion des risques, optimiser vos processus métier et structurer vos audits.
              Grâce à ses fonctionnalités intuitives, il permet à vos équipes de collaborer efficacement tout en gardant le contrôle total sur les informations sensibles.
            </p>
            <p className="text-lg">
              Notre vision est de créer un environnement où la gestion des risques devient simple, transparente et intégrée à vos activités quotidiennes. 
              Avec Cartopousse, vous pilotez vos opérations, vos recommandations et vos plans d'audit avec confiance et sérénité.
            </p>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="bg-gradient-to-br from-gray-900 via-black to-gray-900 text-white py-20 relative overflow-hidden">
        <div className="absolute inset-0">
          <div className="absolute top-0 left-1/4 w-96 h-96 bg-green-500/10 rounded-full blur-3xl"></div>
          <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-green-600/10 rounded-full blur-3xl"></div>
        </div>
        
        <div className="container mx-auto px-4 sm:px-6 text-center max-w-3xl relative z-10">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Prêt à simplifier la gestion de vos{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-green-400 to-emerald-400">
              risques
            </span>
            {' '}et de vos{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-green-400 to-emerald-400">
              audits
            </span>
            {' '}?
          </h2>
          <p className="text-lg mb-8 text-gray-300">
            Rejoignez dès aujourd'hui les organisations qui font confiance à <span className="text-green-400 font-semibold">Cartopousse</span>.
          </p>
          <Link to="/login" className="inline-flex items-center gap-2 bg-green-600 text-white px-10 py-4 rounded-xl text-base font-semibold hover:bg-green-700 transition-all duration-300 shadow-xl hover:shadow-green-500/50 hover:scale-105">
            Commencer maintenant
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
            </svg>
          </Link>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="py-20 bg-gray-50">
        <div className="container mx-auto px-4 sm:px-6">
          <div className="text-center mb-16">
            <div className="inline-flex items-center justify-center gap-2 bg-green-100 rounded-full px-4 py-2 mb-4">
              <Phone className="text-green-600 h-5 w-5" />
              <span className="text-green-700 font-semibold text-sm">Contact</span>
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              Contactez-nous
            </h2>
            <p className="text-gray-600 max-w-2xl mx-auto">
              Une question ? Notre équipe est là pour vous aider
            </p>
          </div>

          <div className="grid lg:grid-cols-2 gap-12 max-w-6xl mx-auto">
            {/* Contact Form with Tabs */}
            <div className="bg-white p-8 rounded-2xl shadow-lg">
              {/* Tab Headers */}
              <div className="flex gap-2 mb-6 bg-gray-100 p-1 rounded-xl">
                <button
                  onClick={() => setActiveTab('assistance')}
                  className={`flex-1 py-3 px-4 rounded-lg text-sm font-semibold transition-all duration-300 ${
                    activeTab === 'assistance'
                      ? 'bg-white text-green-600 shadow-md'
                      : 'text-gray-600 hover:text-gray-900'
                  }`}
                >
                  Assistance
                </button>
                <button
                  onClick={() => setActiveTab('account')}
                  className={`flex-1 py-3 px-4 rounded-lg text-sm font-semibold transition-all duration-300 ${
                    activeTab === 'account'
                      ? 'bg-white text-green-600 shadow-md'
                      : 'text-gray-600 hover:text-gray-900'
                  }`}
                >
                  Création de compte
                </button>
              </div>

              {/* Assistance Form */}
              {activeTab === 'assistance' && (
                <div className="space-y-6">
                  {/* Success/Error Message */}
                  {submitStatus && (
                    <div className={`p-4 rounded-lg text-sm ${
                      submitStatus.type === 'success' 
                        ? 'bg-green-100 text-green-800 border border-green-300' 
                        : 'bg-red-100 text-red-800 border border-red-300'
                    }`}>
                      {submitStatus.message}
                    </div>
                  )}
                  <div>
                    <label className="block text-gray-700 font-semibold mb-2 text-sm">Nom</label>
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleInputChange}
                      placeholder="Votre nom"
                      className={`w-full px-4 py-3 text-sm border rounded-xl focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all ${
                        errors.name ? 'border-red-500' : 'border-gray-300'
                      }`}
                    />
                    {errors.name && <p className="text-red-500 text-xs mt-1.5">{errors.name}</p>}
                  </div>
                  
                  <div>
                    <label className="block text-gray-700 font-semibold mb-2 text-sm">Email</label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      placeholder="Votre email"
                      className={`w-full px-4 py-3 text-sm border rounded-xl focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all ${
                        errors.email ? 'border-red-500' : 'border-gray-300'
                      }`}
                    />
                    {errors.email && <p className="text-red-500 text-xs mt-1.5">{errors.email}</p>}
                  </div>
                  
                  <div>
                    <label className="block text-gray-700 font-semibold mb-2 text-sm">Téléphone</label>
                    <input
                      type="tel"
                      name="telephone"
                      value={formData.telephone}
                      onChange={handleInputChange}
                      placeholder="Votre téléphone (optionnel)"
                      className={`w-full px-4 py-3 text-sm border rounded-xl focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all ${
                        errors.telephone ? 'border-red-500' : 'border-gray-300'
                      }`}
                    />
                    {errors.telephone && <p className="text-red-500 text-xs mt-1.5">{errors.telephone}</p>}
                  </div>
                  
                  <div>
                    <label className="block text-gray-700 font-semibold mb-2 text-sm">Message</label>
                    <textarea
                      name="message"
                      value={formData.message}
                      onChange={handleInputChange}
                      placeholder="Votre message"
                      rows={5}
                      className={`w-full px-4 py-3 text-sm border rounded-xl focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all resize-none ${
                        errors.message ? 'border-red-500' : 'border-gray-300'
                      }`}
                    />
                    {errors.message && <p className="text-red-500 text-xs mt-1.5">{errors.message}</p>}
                  </div>
                  
                  <button
                    onClick={handleSubmit}
                    disabled={isSubmitting}
                    className="w-full inline-flex items-center justify-center bg-green-600 text-white py-4 rounded-xl text-sm font-semibold hover:bg-green-700 transition-all duration-300 shadow-lg hover:shadow-green-500/50 disabled:opacity-70 disabled:cursor-not-allowed"
                  >
                    {isSubmitting ? (
                      <>
                        <Loader2 className="h-4 w-4 mr-2 animate-spin" />
                        Envoi en cours...
                      </>
                    ) : 'Envoyer le message'}
                  </button>

                  {submitStatus && (
                    <div className={`p-4 rounded-lg text-sm ${
                      submitStatus.type === 'success'
                        ? 'bg-green-100 text-green-800 border border-green-300'
                        : 'bg-red-100 text-red-800 border border-red-300'
                    }`}>
                      {submitStatus.message}
                    </div>
                  )}
                </div>
              )}

              {/* Account Creation Request Form */}
              {activeTab === 'account' && (
                <div className="space-y-6">

                  <div>
                    <label className="block text-gray-700 font-semibold mb-2 text-sm">Nom de l'organisation</label>
                    <input
                      type="text"
                      name="name"
                      value={accountFormData.name}
                      onChange={handleAccountInputChange}
                      placeholder="Nom de l'organisation"
                      className={`w-full px-4 py-3 text-sm border rounded-xl focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all ${
                        accountErrors.name ? 'border-red-500' : 'border-gray-300'
                      }`}
                    />
                    {accountErrors.name && <p className="text-red-500 text-xs mt-1.5">{accountErrors.name}</p>}
                  </div>

                  <div>
                    <label className="block text-gray-700 font-semibold mb-2 text-sm">Description (optionnel)</label>
                    <textarea
                      name="organisation_description"
                      value={accountFormData.organisation_description}
                      onChange={handleAccountInputChange}
                      placeholder="Brève description de votre organisation"
                      rows={2}
                      className="w-full px-4 py-3 text-sm border border-gray-300 rounded-xl focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all resize-none"
                    />
                  </div>

                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <label className="block text-gray-700 font-semibold mb-2 text-sm">Prénom du responsable</label>
                      <input
                        type="text"
                        name="first_name"
                        value={accountFormData.first_name}
                        onChange={handleAccountInputChange}
                        placeholder="Prénom"
                        className="w-full px-4 py-3 text-sm border border-gray-300 rounded-xl focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all"
                      />
                    </div>
                    <div>
                      <label className="block text-gray-700 font-semibold mb-2 text-sm">Nom du responsable</label>
                      <input
                        type="text"
                        name="last_name"
                        value={accountFormData.last_name}
                        onChange={handleAccountInputChange}
                        placeholder="Nom"
                        className="w-full px-4 py-3 text-sm border border-gray-300 rounded-xl focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all"
                      />
                    </div>
                  </div>

                  <div>
                    <label className="block text-gray-700 font-semibold mb-2 text-sm">Email</label>
                    <input
                      type="email"
                      name="email"
                      value={accountFormData.email}
                      onChange={handleAccountInputChange}
                      placeholder="Votre adresse email"
                      className={`w-full px-4 py-3 text-sm border rounded-xl focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all ${
                        accountErrors.email ? 'border-red-500' : 'border-gray-300'
                      }`}
                    />
                    {accountErrors.email && <p className="text-red-500 text-xs mt-1.5">{accountErrors.email}</p>}
                  </div>


                  <div>
                    <label className="block text-gray-700 font-semibold mb-2 text-sm">Contact</label>
                    <input
                      type="text"
                      name="contact"
                      value={accountFormData.contact}
                      onChange={handleAccountInputChange}
                      placeholder="Votre numéro de contact"
                      className={`w-full px-4 py-3 text-sm border rounded-xl focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all ${
                        accountErrors.contact ? 'border-red-500' : 'border-gray-300'
                      }`}
                    />
                    {accountErrors.contact && <p className="text-red-500 text-xs mt-1.5">{accountErrors.contact}</p>}
                  </div>

                  {/* <div>
                    <label className="block text-gray-700 font-semibold mb-2 text-sm">Service</label>
                    <div className='flex items-center gap-2'>

                     <input
                      type="text"
                      name="service"
                      value={accountFormData.service}
                      onChange={handleAccountInputChange}
                      placeholder="Nom"
                      className={`w-full px-4 py-3 text-sm border rounded-xl focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all ${
                        accountErrors.service ? 'border-red-500' : 'border-gray-300'
                      }`}
                    />

                    <input
                      type="text"
                      name="service"
                      value={accountFormData.service}
                      onChange={handleAccountInputChange}
                      placeholder="Prenom"
                      className={`w-full px-4 py-3 text-sm border rounded-xl focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all ${
                        accountErrors.service ? 'border-red-500' : 'border-gray-300'
                      }`}
                    />

                    </div>
                    {accountErrors.service && <p className="text-red-500 text-xs mt-1.5">{accountErrors.service}</p>}
                  </div> */}

                  <div>
                    <label className="block text-gray-700 font-semibold mb-2 text-sm">Service</label>
                    <input
                      type="text"
                      name="service"
                      value={accountFormData.service}
                      onChange={handleAccountInputChange}
                      placeholder="Nom du service"
                      className={`w-full px-4 py-3 text-sm border rounded-xl focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all ${
                        accountErrors.service ? 'border-red-500' : 'border-gray-300'
                      }`}
                    />
                    {accountErrors.service && <p className="text-red-500 text-xs mt-1.5">{accountErrors.service}</p>}
                  </div>

                  <div>
                    <label className="block text-gray-700 font-semibold mb-2 text-sm">Raison/plus de détails</label>
                    <textarea
                      name="reason"
                      value={accountFormData.reason}
                      onChange={handleAccountInputChange}
                      placeholder="Raison de la demande de création de compte"
                      rows={5}
                      className={`w-full px-4 py-3 text-sm border rounded-xl focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all resize-none ${
                        accountErrors.reason ? 'border-red-500' : 'border-gray-300'
                      }`}
                    />
                    {accountErrors.reason && <p className="text-red-500 text-xs mt-1.5">{accountErrors.reason}</p>}
                  </div>
                  
                  <button
                    onClick={handleAccountSubmit}
                    disabled={isAccountSubmitting}
                    className="w-full inline-flex items-center justify-center bg-green-600 text-white py-4 rounded-xl text-sm font-semibold hover:bg-green-700 transition-all duration-300 shadow-lg hover:shadow-green-500/50 disabled:opacity-70 disabled:cursor-not-allowed"
                  >
                    {isAccountSubmitting ? (
                      <>
                        <Loader2 className="h-4 w-4 mr-2 animate-spin" />
                        Envoi en cours...
                      </>
                    ) : 'Envoyer la demande'}
                  </button>

                  {accountSubmitStatus && (
                    <div className={`p-4 rounded-lg text-sm ${
                      accountSubmitStatus.type === 'success'
                        ? 'bg-green-100 text-green-800 border border-green-300'
                        : 'bg-red-100 text-red-800 border border-red-300'
                    }`}>
                      {accountSubmitStatus.message}
                    </div>
                  )}
                </div>
              )}
            </div>

            {/* Contact Information - Keep as is */}
            <div className="space-y-6">
              <div className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-shadow">
                <h3 className="text-xl font-bold text-gray-900 mb-6">Autres moyens de contact</h3>
                
                <div className="space-y-6">
                  <div className="flex items-start group">
                    <div className="bg-gradient-to-br from-green-400 to-green-600 p-3 rounded-xl mr-4 group-hover:scale-110 transition-transform">
                      <Phone className="text-white h-6 w-6" />
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-900 mb-1">Téléphone</h4>
                      <p className="text-gray-600">+237 652 75 19 99</p>
                    </div>
                  </div>
                  
                  <div className="flex items-start group">
                    <div className="bg-gradient-to-br from-blue-400 to-blue-600 p-3 rounded-xl mr-4 group-hover:scale-110 transition-transform">
                      <Mail className="text-white h-6 w-6" />
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-900 mb-1">Email</h4>
                      <p className="text-gray-600">callcenter@ngombe.org</p>
                    </div>
                  </div>
                  
                  <div className="flex items-start group">
                    <div className="bg-gradient-to-br from-purple-400 to-purple-600 p-3 rounded-xl mr-4 group-hover:scale-110 transition-transform">
                      <MapPin className="text-white h-6 w-6" />
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-900 mb-1">Localisation</h4>
                      <p className="text-gray-600">Douala, Cameroun</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="bg-gradient-to-br from-green-50 to-green-100 p-8 rounded-2xl border border-green-200">
                <h4 className="font-bold text-gray-900 mb-3">Heures d'ouverture</h4>
                <div className="space-y-2 text-sm text-gray-700">
                  <p className="flex justify-between">
                    <span className="font-medium">Lun - Ven:</span>
                    <span>8h00 - 18h00</span>
                  </p>
                  <p className="flex justify-between">
                    <span className="font-medium">Samedi:</span>
                    <span>9h00 - 14h00</span>
                  </p>
                  <p className="flex justify-between">
                    <span className="font-medium">Dimanche:</span>
                    <span>Fermé</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="container mx-auto px-4 sm:px-6">
          <div className="text-center">
            <div className="text-2xl font-bold mb-6">
              Carto<span className="text-green-500">pousse</span>
            </div>
            
            <div className="flex flex-wrap justify-center gap-8 text-sm mb-6">
              <a href="#fonctionnalites" className="text-gray-400 hover:text-green-400 transition-colors font-medium">
                Fonctionnalités
              </a>
              <a href="#apropos" className="text-gray-400 hover:text-green-400 transition-colors font-medium">
                À propos
              </a>
              <a href="#contact" className="text-gray-400 hover:text-green-400 transition-colors font-medium">
                Contact
              </a>
            </div>
            
            <div className="border-t border-gray-800 pt-6">
              <p className="text-gray-400 text-sm">© {new Date().getFullYear() } Cartopousse - Tous droits réservés.</p>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}